import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { newsApi } from "../api/newsApi";

export default function NewsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const parseDate = (v) => {
    if (!v) return null;

    const dt = v instanceof Date ? v : new Date(String(v));

    return Number.isNaN(dt.getTime()) ? null : dt;
  };

  const formatDateTime = (v) => {
    const dt = parseDate(v);

    if (!dt) return "—";

    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();
    const hh = String(dt.getHours()).padStart(2, "0");
    const min = String(dt.getMinutes()).padStart(2, "0");

    return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
  };

  const getInsertedDate = (x) => x?.insertedDate ?? x?.InsertedDate ?? null;
  const getManualInsertedDate = (x) => x?.manualInsertedDate ?? x?.ManualInsertedDate ?? null;
  const getUpdateDate = (x) => x?.updateDate ?? x?.UpdateDate ?? null;
  const getYoutubeLink = (x) => x?.youtubeLink ?? x?.YoutubeLink ?? "";

  const load = async () => {
    setLoading(true);
    setErr("");

    try {
      const res = await newsApi.getAll();

      const sorted = (res.data || []).slice().sort((a, b) => {
        const da = parseDate(getInsertedDate(a))?.getTime() ?? 0;
        const db = parseDate(getInsertedDate(b))?.getTime() ?? 0;

        return db - da;
      });

      setItems(sorted);
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (id) => {
    if (!window.confirm("Silinsin?")) return;

    try {
      await newsApi.remove(id);
      await load();
    } catch (e) {
      alert(e?.response?.data || e.message || "Delete failed");
    }
  };

  const wrapCell = useMemo(
    () => ({
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
      lineHeight: 1.35,
    }),
    []
  );

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <h1 className="pageTitle" style={{ margin: 0 }}>
          Xəbərlər
        </h1>

        <Link className="btn btnPrimary" to="/news/new">
          Yenisin yarat
        </Link>
      </div>

      <div style={{ marginTop: 14 }}>
        {loading ? (
          <div className="card">
            <div className="cardBody">Yüklənir...</div>
          </div>
        ) : err ? (
          <div className="card">
            <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>
              {String(err)}
            </div>
          </div>
        ) : (
          <div className="tableWrap">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 70 }}>#</th>
                  <th style={{ width: 330 }}>Başlıq</th>
                  <th style={{ width: 470 }}>Məzmun</th>
                  <th style={{ width: 170 }}>Tarix</th>
                  <th style={{ width: 170 }}>Yaradılma tarixi</th>
                  <th style={{ width: 170 }}>Redakte edilmə tarixi</th>
                  <th style={{ width: 230 }}>Media</th>
                  <th style={{ width: 210 }}>Əməliyyat</th>
                </tr>
              </thead>

              <tbody>
                {items.map((x, index) => {
                  const id = x.id ?? x.Id;
                  const hasImage = Boolean(x.hasImage ?? x.HasImage);
                  const youtubeLink = getYoutubeLink(x);

                  return (
                    <tr key={id ?? index}>
                      <td>{index + 1}</td>

                      <td style={{ fontWeight: 800, ...wrapCell, maxWidth: 330 }}>
                        <div>
                          <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                          {x.titleAz ?? x.TitleAz ?? ""}
                        </div>

                        <div>
                          <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                          {x.titleEn ?? x.TitleEn ?? ""}
                        </div>

                        <div>
                          <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                          {x.titleRu ?? x.TitleRu ?? ""}
                        </div>
                      </td>

                      <td
                        style={{
                          color: "rgba(255,255,255,.78)",
                          ...wrapCell,
                          maxWidth: 470,
                        }}
                      >
                        <div>
                          <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                          {x.contentAz ?? x.ContentAz ?? ""}
                        </div>

                        <div>
                          <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                          {x.contentEn ?? x.ContentEn ?? ""}
                        </div>

                        <div>
                          <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                          {x.contentRu ?? x.ContentRu ?? ""}
                        </div>
                      </td>

                      <td style={{ whiteSpace: "nowrap", color: "rgba(255,255,255,.78)" }}>
                        {formatDateTime(getManualInsertedDate(x))}
                      </td>

                      <td style={{ whiteSpace: "nowrap", color: "rgba(255,255,255,.78)" }}>
                        {formatDateTime(getInsertedDate(x))}
                      </td>

                      <td style={{ whiteSpace: "nowrap", color: "rgba(255,255,255,.78)" }}>
                        {formatDateTime(getUpdateDate(x))}
                      </td>

                      <td>
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                          {youtubeLink ? (
                            <span className="badge badgeOk">YouTube video var</span>
                          ) : (
                            <span className="badge badgeNo">Video yoxdur</span>
                          )}

                          {youtubeLink ? (
                            <a
                              href={youtubeLink}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                color: "rgba(255,255,255,.85)",
                                fontSize: 12,
                                textDecoration: "underline",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                              }}
                            >
                              Linkə bax
                            </a>
                          ) : null}

                          {hasImage ? (
                            <img
                              className="imgThumb"
                              alt="news"
                              src={newsApi.getImageUrl(id) + `?t=${Date.now()}`}
                            />
                          ) : (
                            <span className="badge badgeNo">Şəkil yoxdur</span>
                          )}
                        </div>
                      </td>

                      <td>
                        <div className="btnRow">
                          <Link className="btn" to={`/news/${id}/edit`}>
                            Redakte et
                          </Link>

                          <button className="btn btnDanger" onClick={() => onDelete(id)}>
                            Sil
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}

                {items.length === 0 ? (
                  <tr>
                    <td colSpan="8" style={{ color: "rgba(255,255,255,.6)" }}>
                      Heç nə yoxdur.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}